// 引入
import bluetitle from "../components/common/tabtitle";
import longbluetitle from "../components/common/longtabtitle";
import theader from "../components/common/theader";
import tmenu from "../components/common/menu";
import stafftitle from "../components/common/stafftitle";
import tabs from "../components/common/tabs";
import bluetabs from "../components/common/bluetabs";
import vidobox from "../components/common/vidobox";
import jingbox from "../components/common/jingbox";
import ertitle from "../components/common/ertitle";
import videoone from "../components/common/videoone";
import videodan from "../components/common/videodan";
import videosi from "../components/common/videosi";

export default {
  install(Vue) {
    // 注册全局组件
    Vue.component("bluetitle", bluetitle);
    Vue.component("longbluetitle", longbluetitle);
    Vue.component("theader", theader);
    Vue.component("tmenu", tmenu);
    Vue.component("stafftitle", stafftitle);
    Vue.component("tabs", tabs);
    Vue.component("bluetabs", bluetabs);
    Vue.component("vidobox", vidobox);
    Vue.component("jingbox", jingbox);
    Vue.component("ertitle", ertitle);
    Vue.component("videoone", videoone);
    Vue.component("videodan", videodan);
    Vue.component("videosi", videosi);
  },
};
